// client/src/screens/admin/products/TextilesProductForm.jsx

import React from "react";

import TextilesFormStatus from "./textile/TextilesFormStatus";
import TextilesFormActions from "./textile/TextilesFormActions";
import TextilesFormContent from "./textile/TextilesFormContent";
import useTextilesProductForm from "./textile/useTextilesProductForm";

import { SHOP_KEY } from "./textile/TextilesProductForm.shared";

const TextilesProductForm = ({
  initialData,
  onSubmit,
  loading = false,
  error = "",
  errorMeta = null,
  saveSuccess = false,
  submitLabel = "Save Textile",
  shopKey = SHOP_KEY,
  isEditing = false,
}) => {
  const {
    form,
    draftRestored,
    submitError,
    submitDisabled,
    conflictMessage,

    setField,
    setVariantField,
    setImages,
    addVariant,
    removeVariant,
    discardDraft,
    handleSubmit,
  } = useTextilesProductForm({
    initialData,
    onSubmit,
    loading,
    error,
    errorMeta,
    saveSuccess,
    shopKey,
  });

  return (
    <form className="admin-product-form" onSubmit={handleSubmit}>
      <TextilesFormStatus
        draftRestored={draftRestored}
        isEditing={isEditing}
        conflictMessage={conflictMessage}
        error={error}
        submitError={submitError}
        submitDisabled={submitDisabled}
        onDiscardDraft={discardDraft}
      />

      <TextilesFormContent
        form={form}
        shopKey={shopKey || SHOP_KEY}
        submitDisabled={submitDisabled}
        setField={setField}
        setVariantField={setVariantField}
        setImages={setImages}
        addVariant={addVariant}
        removeVariant={removeVariant}
      />

      <TextilesFormActions
        loading={loading}
        submitLabel={submitLabel}
        submitDisabled={submitDisabled}
        onReset={discardDraft}
      />
    </form>
  );
};

export default TextilesProductForm;
